import { usePostMessageNavigation, useSendPreLoadComplete } from './usePostMessageTool';
import useStyles from './style';

/**
 * 空白入口页面
 * 用于快速显示 iframe，不加载任何业务逻辑
 * 监听父窗口的 postMessage 事件，收到消息后跳转到真正的业务地址
 */
export default function BlankEntry(props: { mode: 'home' | 'aluminum' | 'hard' | 'quanwu' }) {
  const { styles } = useStyles();

  // 发送预加载完成消息
  useSendPreLoadComplete(props.mode);

  // 使用抽离的 hook 处理 postMessage 导航
  usePostMessageNavigation(props.mode);

  // 返回空白页面
  return (
    <div className={styles.blankEntryContainer} />
  );
}

